<template>
  <div>
    <Header></Header>
    <main id="content" role="main" class="bg-light">
      <div class="container space-top-2 space-top-lg-1 space-bottom-2 space-bottom-lg-2">
        <div class="w-lg-80 mx-auto">
          <div class="mb-5">
            <router-link class="font-weight-bold" to="/recruit">
              <i class="fas fa-angle-left fa-sm mr-1"></i>
              返回列表
            </router-link>
          </div>
          <div class="card space-bottom-2 p-4 p-md-7">
            <div class="row justify-content-sm-between align-items-sm-center mb-5">
              <div class="col-sm mb-3 mb-sm-0">
                <h1 class="h2">{{detailData.recruitJob?detailData.recruitJob.name:''}}</h1>
                <p class="mb-0">{{getDictName(getDictDetail('address'),detailData.address)}}  {{detailData.fullTime?'全职':'兼职'}}</p>
              </div>

              <div class="col-sm-auto text-sm-right">
                <a class="js-go-to position-static btn btn-primary transition-3d-hover" href="#joinus" data-hs-go-to-options='{
                  "targetSelector": "#applyForJob",
                  "compensationSelector": "#logoAndNav",
                  "offsetTop": 0,
                  "position": null,
                  "animationIn": false,
                  "animationOut": false
                 }'>
                  立即申请职位
                </a>
              </div>
            </div>
            <div class="mb-5">
              <p>
                {{describe}}
              </p>
            </div>
            <div class="mb-5">
              <h2 class="h4">我们提供:</h2>
              <ul  v-if="detailData.benefit">
                <li v-for="(item,index) in getFldy(detailData.benefit)" :key="index">
                  {{getDictName(getDictDetail('benefit'),item)}}
                </li>
              
              </ul>
            </div>
            <div class="mb-5">
              <h3 class="h4">要求:</h3>
              <p v-html="detailData.request"></p>
            </div>
            
            <div id="joinus" class="border-top text-center pt-9 mb-5 mb-md-9">
              <h2>加入我们</h2>
            </div>
            <form id="applyForJob" class="js-validate">
              <div class="row">
                <div class="col-md-6 mb-3 mb-md-5">
                  <!-- Input -->
                  <div class="js-form-message">
                    <label class="input-label" for="fullNameLabel">您的名字</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="firstName" id="fullNameLabel" placeholder="您的名字" aria-label="您的名字" required data-msg="Please enter your frist name." />
                    </div>
                  </div>
                  <!-- End Input -->
                </div>

                <div class="col-md-6 mb-3 mb-md-5">
                  <!-- Input -->
                  <div class="js-form-message">
                    <label class="input-label" for="lastNameLabel">应聘职务</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="lastName" id="lastNameLabel" placeholder="应聘职务" aria-label="应聘职务" required data-msg="Please enter your last name." />
                    </div>
                  </div>
                  <!-- End Input -->
                </div>

                <div class="col-md-6 mb-3 mb-md-5">
                  <!-- Input -->
                  <div class="js-form-message">
                    <label class="input-label" for="emailAddressLabel">电子邮件</label>
                    <div class="input-group">
                      <input type="email" class="form-control" name="emailAddress" id="emailAddressLabel" placeholder="您的邮件" aria-label="您的邮件" required data-msg="Please enter a valid email address." />
                    </div>
                  </div>
                  <!-- End Input -->
                </div>

                <div class="col-md-6 mb-3 mb-md-5">
                  <!-- Input -->
                  <div class="js-form-message">
                    <label class="input-label" for="urlLabel">您的线上简历/个人网站
                      <span class="text-muted font-weight-normal ml-1">(选填)</span></label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="URL" id="urlLabel" placeholder="如果您有智联招聘主页请提供" aria-label="如果您有智联招聘主页请提供" />
                    </div>
                  </div>
                  <!-- End Input -->
                </div>
              </div>

              <div class="mb-3 mb-md-5">
                <!-- Input -->
                <div class="js-form-message">
                  <label class="input-label">您对我们有什么话
                    <textarea class="form-control" rows="6" name="answer" placeholder="输入内容请小于200字..." aria-label="输入内容请小于200字..." required data-msg="Please enter an answer."></textarea>
                  </label>
                </div>
                <div class="text-center mt-4">
                  <button type="submit" class="btn btn-primary transition-3d-hover">
                    提交信息
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js";
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js";
import "@/assets/vendor/hs-video-player/dist/hs-video-player.min.js";
import "@/assets/js/hs.validation.js";
import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/css/theme.css";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
// import "@/assets/vendor/dropzone/dist/min/dropzone.min.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.dropzone.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Header from "@/components/header";
import Footer from "@/components/footer";
import { getZhaoPinList,getProductInfo } from '@/request/index'
import dictMixins from '@/mixins/dictMixins'
export default {
  components: {
    Header,
    Footer,
  },
  mounted() {
    $(document).ready(function () {
      // initialization of header
      var header = new HSHeader($('#header')).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($('.js-mega-menu'), {
        desktop: {
          position: 'left'
        }
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold('.js-hs-unfold-invoker').init();

      // initialization of show animations
      $('.js-animation-link').each(function () {
        var showAnimation = new HSShowAnimation($(this)).init();
      });

      // initialization of form validation
      $('.js-validate').each(function () {
        $.HSCore.components.HSValidation.init($(this), {
          rules: {
            confirmPassword: {
              equalTo: '#signupPassword'
            }
          }
        });
      });

      // initialization of dropzone
      $('.js-dropzone').each(function () {
        var dropzone = $.HSCore.components.HSDropzone.init('#' + $(this).attr('id'));
      });

      // initialization of go to
      $('.js-go-to').each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
    });
  },
  mixins: [dictMixins],
  data(){
    return{
      detailData:{},
      describe:null
    }
  },
  created() {
    if (this.$route.query) {
      let id = this.$route.query.id  //接收id
      this.getDetail(id)
      this.getFldy('1')
    }
  },
  methods: {
    //获取福利待遇
    getFldy(val){
      let daiyus = []
      daiyus = val.split(',')
      return daiyus
    },
    getDetail(id) {
      getZhaoPinList({ page: 0, size: 999,id:id }).then((res) => {
        this.detailData = res.data.content[0]
      })
      getProductInfo({type:5}).then(res=>{
        this.describe =  res.data.content.length>0?res.data.content[0].detail:''
      })
    },

  }
};
</script>

<style scoped>
.font-weight-bold {
  text-decoration: none;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0.0625rem solid #e7eaf3;
  border-radius: 0.3125rem;
}
.mb-sm-0 .h2,
.mb-md-9 h2 {
  margin-bottom: 0.5rem;
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.mb-sm-0 .mb-0 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.mb-5 p,
.mb-5 ul li {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.mb-5 .h4 {
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
</style>


// WEBPACK FOOTER //
// src/view/Recruitdetail.vue